import React from 'react';
import { getText } from '../../i18n';
import styles from './Billing.module.scss';

const BillingSMSReportPage = () => {
    return (
        <div className={styles.pageContainer}>
            <div className="page-header">
                <h1>{getText('msg_8bc86473f372')}</h1>
            </div>
            <div className={styles.pageContent}>
                <p>{getText('msg_292b7e20157d')}</p>
            </div>
        </div>
    );
};

export default BillingSMSReportPage;
